export default __webpack_public_path__ + "static/media/tutorial.4095c934.png";